import { constants } from 'actions/page';

const initialState = {
  header: '',
  isMobileSidebarOpen: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.CHANGE_HEADER:
      return { ...state, header: payload };
    case constants.TOGGLE_MOBILE_SIDEBAR:
      return { ...state, isMobileSidebarOpen: !state.isMobileSidebarOpen };
    default:
      return state;
  }
};
